import React from "react";

function CustomScrollbar(props) {
  return (
    <div style={{ maxHeight: "80vh", overflow: "auto" }}>{props.children}</div>
  );
}

export default CustomScrollbar;
